module.exports = "/images/ilustracion-login.svg?0fd2056a663dbd7b45bf5f5effbd19ad";